import { render, staticRenderFns } from "./NavComps.vue?vue&type=template&id=124b08c8&scoped=true"
import script from "./NavComps.vue?vue&type=script&lang=js"
export * from "./NavComps.vue?vue&type=script&lang=js"
import style0 from "./NavComps.vue?vue&type=style&index=0&id=124b08c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b08c8",
  null
  
)

export default component.exports